/**
 * @tabler/icons-react v2.47.0 - MIT
 */

import createReactComponent from '../createReactComponent.js';

var IconPackage = createReactComponent("package", "IconPackage", [
  ["path", { d: "M12 3l8 4.5l0 9l-8 4.5l-8 -4.5l0 -9l8 -4.5", key: "svg-0" }],
  ["path", { d: "M12 12l8 -4.5", key: "svg-1" }],
  ["path", { d: "M12 12l0 9", key: "svg-2" }],
  ["path", { d: "M12 12l-8 -4.5", key: "svg-3" }],
  ["path", { d: "M16 5.25l-8 4.5", key: "svg-4" }]
]);

export { IconPackage as default };
//# sourceMappingURL=IconPackage.js.map
